angular.module('erp.other.clickShopOpening').run(['$templateCache', function($templateCache) {
  $templateCache.put("tpl/outbox.htm",
    "<div class=\"clickShopOpening-css\">\n" +
    "  <div class=\"swiper-container swiper-container-topBanner transformscalesw\" ng-if=\"vm.Banner.topBanner\">\n" +
    "    <div class=\"swiper-wrapper\">\n" +
    "      <div class=\"swiper-slide\" ng-repeat=\"item in vm.Banner.topBanner\">\n" +
    "        <div class=\"wp_100 cursor_pointer\" style=\"aspect-ratio: 1263 / 328;\" ng-click=\"vm.goblank(item)\">\n" +
    "          <a ng-href=\"{{item.url}}\"><img width=\"100%\" height=\"100%\" ng-src=\"{{item.image}}\" alt=\"\" srcset=\"\" /></a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.Banner.topBanner.length > 1\" class=\"swiper-pagination\"></div>\n" +
    "    <div ng-if=\"vm.Banner.topBanner.length > 1\" class=\"swiper-button-next transformscaletop\"></div>\n" +
    "    <div ng-if=\"vm.Banner.topBanner.length > 1\" class=\"swiper-button-prev transformscaletop\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"all-center-clickShopOpening container\">\n" +
    "    <div class=\"filter-bar\">\n" +
    "        <div class=\"select-box select3-h-40\" ng-repeat=\"item in vm.countryList\">\n" +
    "          <mg-widget-select3\n" +
    "            on-change=\"vm.onChange(item)\"\n" +
    "            placeholder=\"{{item.name}}\"\n" +
    "            ng-model=\"item.selectedIdlist\"\n" +
    "            list=\"item.labelList\"\n" +
    "            value-key='labelId'\n" +
    "            name-key=\"labelName\"\n" +
    "            select-name=\"labelName\"\n" +
    "            select-value=\"labelId\">\n" +
    "          </mg-widget-select3>\n" +
    "        </div>\n" +
    "    \n" +
    "        <div class=\"input-box\">\n" +
    "          <input type=\"text\" ng-model=\"vm.siteManage\" placeholder=\"输入平台关键词\" />\n" +
    "          <i class=\"icon fa fa-search\" style=\"cursor: pointer;\" ng-click=\"vm.getSiteManage()\"></i>\n" +
    "        </div>\n" +
    "    \n" +
    "        <button style=\"width: 130px;\" ng-click=\"vm.rotate()\" class=\"reset-btn\">\n" +
    "          <i class=\"fa fa-rotate-right\"></i>\n" +
    "          重置\n" +
    "        </button>\n" +
    "      </div>\n" +
    "    \n" +
    "      <!-- 卡片容器 -->\n" +
    "      <div class=\"card-container\">\n" +
    "        <!-- Amazon 卡片 -->\n" +
    "        <div class=\"card\" ng-repeat=\"item in vm.listdate\">\n" +
    "          <div class=\"card-header\">\n" +
    "            <div class=\"logo\">\n" +
    "                <img ng-src=\"{{item.logo}}\" alt=\"\" srcset=\"\">\n" +
    "            </div>\n" +
    "            <div style=\"flex: 1;\">\n" +
    "                <div class=\"card-title\">{{item.siteName}}</div>\n" +
    "                <div class=\"card-desc\">\n" +
    "                    {{item.introduction}}\n" +
    "                </div>\n" +
    "                <div class=\"card-actions\">\n" +
    "                  <button class=\"btn btn-primary\" ng-click=\"vm.OpenRegistration(item)\" style=\"flex: 1;\">入驻通道</button>\n" +
    "                  <button class=\"btn btn-secondary\" ng-click=\"vm.learnMore(item)\" style=\"flex: 1;\">了解更多</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert alert-warning\" style=\"width: 100%;\" ng-show=\"!vm.listdate || vm.listdate.length === 0\">\n" +
    "          <i class=\"fa fa-fw fa-warning\"></i>\n" +
    "          暂无数据。\n" +
    "        </div>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);
